import SectionLabel from "@/components/base/SectionLabel";
import { caseStudiesData } from "@/mocks/caseStudiesData";

export default function AboutSection() {
  return (
    <section id="about-cases" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="max-w-3xl mx-auto text-center mb-10 md:mb-14 reveal">
          <SectionLabel
            label={caseStudiesData.about.label}
            className="mb-3"
          />
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-5 md:mb-6">
            {caseStudiesData.about.title}
          </h2>
          <div className="space-y-3 text-left md:text-left">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed font-bold">
              {caseStudiesData.about.description}
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              {caseStudiesData.about.description2}
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              {caseStudiesData.about.description3}
            </p>
          </div>
        </div>

        <div className="reveal max-w-3xl mx-auto">
          <div className="flex flex-col md:flex-row items-center gap-0 md:gap-0">
            {caseStudiesData.about.flowSteps.map((step, idx) => (
              <div key={idx} className="flex md:flex-col items-center">
                <div className="flex md:flex-col items-center gap-3 md:gap-2 w-full md:w-auto">
                  <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary-500/10 border border-primary-200/40 flex items-center justify-center flex-shrink-0">
                    <i className={`${step.icon} text-primary-500 text-lg md:text-xl`} />
                  </div>
                  <div className="flex-1 md:text-center py-1">
                    <p className="text-xs md:text-sm text-foreground-800 font-medium leading-tight">
                      {step.label}
                    </p>
                  </div>
                </div>
                {idx < caseStudiesData.about.flowSteps.length - 1 && (
                  <>
                    <div className="hidden md:flex items-center justify-center w-10">
                      <i className="ri-arrow-right-s-line text-primary-300 text-xl" />
                    </div>
                    <div className="md:hidden w-px h-10 bg-primary-200 mx-auto" />
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}